/**
 * Comparação de texto escrito por gente.
 *
 * Quem procura "analise de mix" não digita o acento, e quem procura "NPS" não digita minúscula.
 * Comparar as strings cruas faria a busca falhar exatamente nos casos em que ela mais serve —
 * e o efeito prático seria a pessoa concluir que o item não existe no catálogo.
 */

/** Tira acento sem tirar letra: "Análise" → "Analise", "coração" → "coracao". */
export function semAcento(texto: string): string {
  return texto.normalize("NFD").replace(/\p{Diacritic}/gu, "");
}

/** A forma canônica para comparar: sem acento, minúscula e sem espaço nas pontas. */
export function normalizarParaBusca(texto: string): string {
  return semAcento(texto).toLowerCase().trim();
}
